var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hd-header'),_vm._v(" "),_c('div',{ref:"mainDiv",staticStyle:{"width":"400px","position":"relative"},style:({top:_vm.mainTop+'px', left:_vm.mainLeft+'px'})},[_c('div',{staticStyle:{"font-size":"24px"}},[_vm._v("设置新密码")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"14px","color":"#999999"}},[_vm._v("不可与之前设置过的密码重复")]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"60px"}},[_c('el-form',{ref:"refForm",attrs:{"model":_vm.form}},[_c('el-form-item',{attrs:{"label":"","prop":"password","rules":[{
            required: true,
            message: '请输入新密码',
            trigger: 'blur'
        },{
            min: 6,
            max: 20,
            message: '密码长度6-20位，建议数字和字母组合',
            trigger: 'blur'
        }]}},[_c('el-input',{attrs:{"placeholder":"输入新密码","prefix-icon":"iconfont icon-key","type":"password"},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"","prop":"repeatPassword","rules":[{
            required: true,
            message: '请重复输入新密码',
            trigger: 'blur'
        },{
            min: 6,
            max: 20,
            message: '密码长度6-20位，建议数字和字母组合',
            trigger: 'blur'
        }]}},[_c('el-input',{attrs:{"placeholder":"重复输入新密码","prefix-icon":"iconfont icon-key","type":"password"},model:{value:(_vm.form.repeatPassword),callback:function ($$v) {_vm.$set(_vm.form, "repeatPassword", $$v)},expression:"form.repeatPassword"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"divInput"},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"type":"primary"},on:{"click":_vm.resetPwd}},[_vm._v("重置密码")])],1)]),_vm._v(" "),_c('hd-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c20fead8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/SetNewPassword.vue
// module id = null
// module chunks = 